import {useEffect, useState} from 'react'
import {ISelectOption} from '../utils/core/_model'
import {BASE_URL} from '../modules/config'
import axios from 'axios'
import {mapToSelectOptions} from '../utils/helperFunction/array.helper'

type Voucher = {
  id: 17
  voucher_no: string
  invoice_id: number
  amount: number
  due: number
  created_by: number
  created_at: string
}

const GET_VOUCHRE_LIST_URL = `${BASE_URL}/api/protect/getVoucherList`

const useVoucherList = () => {
  const [opts, setOpts] = useState<Voucher[]>([])
  const [voucherList, setVoucherList] = useState<ISelectOption[]>([])

  useEffect(() => {
    const getVoucherList = async () => {
      try {
        const res = await axios.get(GET_VOUCHRE_LIST_URL)
        const data = await res.data
        const formattedOpts = mapToSelectOptions(data, {
          idKey: 'id',
          labelKey: 'voucher_no',
          valueKey: 'voucher_no',
        })
        setOpts(data || [])
        setVoucherList(formattedOpts || [])
      } catch (error) {
        console.log(error)
      }
    }

    getVoucherList()
  }, [])

  return {voucherList}
}

export default useVoucherList
